import * as actionTypes from "./action_type";

const setPyqTestsData = (payload) => {
  return {
    type: actionTypes.SET_PYQ_TESTS_DATA,
    payload,
  };
};

const setPyqTestsResultData = (payload) => {
  return {
    type: actionTypes.SET_PYQ_TESTS_RESULT_DATA,
    payload,
  };
};

const setPyqMainCurrentTab = (payload) => {
  return {
    type: actionTypes.SET_PYQ_MAIN_CURRENT_TAB,
    payload,
  };
};

const setPyqSubCurrentTab = (payload) => {
  return {
    type: actionTypes.SET_PYQ_SUB_CURRENT_TAB,
    payload,
  };
};

const setPyqCurrentYear = (payload) => {
  return {
    type: actionTypes.SET_PYQ_CURRENT_YEAR,
    payload,
  };
};

export default {
  setPyqTestsData,
  setPyqTestsResultData,
  setPyqMainCurrentTab,
  setPyqSubCurrentTab,
  setPyqCurrentYear,
};
